'use strict';

var cov_1glj2h5u51 = function () {
    var path = '/home/lobo/repos/coliseu-app/src/app/shared/js/ORM/tables.reports.js',
        hash = 'd84361e42bdcfc66d2872d0397ac090f152aab96',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/coliseu-app/src/app/shared/js/ORM/tables.reports.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 29,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 49
                }
            },
            '2': {
                start: {
                    line: 10,
                    column: 1
                },
                end: {
                    line: 27,
                    column: 11
                }
            },
            '3': {
                start: {
                    line: 13,
                    column: 20
                },
                end: {
                    line: 13,
                    column: 60
                }
            },
            '4': {
                start: {
                    line: 16,
                    column: 20
                },
                end: {
                    line: 16,
                    column: 62
                }
            },
            '5': {
                start: {
                    line: 21,
                    column: 20
                },
                end: {
                    line: 21,
                    column: 60
                }
            },
            '6': {
                start: {
                    line: 24,
                    column: 20
                },
                end: {
                    line: 24,
                    column: 62
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 29,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'RestmodFactory',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 27
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 37
                    },
                    end: {
                        line: 28,
                        column: 5
                    }
                },
                line: 9
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 12,
                        column: 24
                    },
                    end: {
                        line: 12,
                        column: 25
                    }
                },
                loc: {
                    start: {
                        line: 12,
                        column: 41
                    },
                    end: {
                        line: 14,
                        column: 17
                    }
                },
                line: 12
            },
            '3': {
                name: '(anonymous_3)',
                decl: {
                    start: {
                        line: 15,
                        column: 24
                    },
                    end: {
                        line: 15,
                        column: 25
                    }
                },
                loc: {
                    start: {
                        line: 15,
                        column: 41
                    },
                    end: {
                        line: 17,
                        column: 17
                    }
                },
                line: 15
            },
            '4': {
                name: '(anonymous_4)',
                decl: {
                    start: {
                        line: 20,
                        column: 24
                    },
                    end: {
                        line: 20,
                        column: 25
                    }
                },
                loc: {
                    start: {
                        line: 20,
                        column: 41
                    },
                    end: {
                        line: 22,
                        column: 17
                    }
                },
                line: 20
            },
            '5': {
                name: '(anonymous_5)',
                decl: {
                    start: {
                        line: 23,
                        column: 24
                    },
                    end: {
                        line: 23,
                        column: 25
                    }
                },
                loc: {
                    start: {
                        line: 23,
                        column: 41
                    },
                    end: {
                        line: 25,
                        column: 17
                    }
                },
                line: 23
            }
        },
        branchMap: {
            '0': {
                loc: {
                    start: {
                        line: 13,
                        column: 27
                    },
                    end: {
                        line: 13,
                        column: 59
                    }
                },
                type: 'cond-expr',
                locations: [{
                    start: {
                        line: 13,
                        column: 37
                    },
                    end: {
                        line: 13,
                        column: 52
                    }
                }, {
                    start: {
                        line: 13,
                        column: 55
                    },
                    end: {
                        line: 13,
                        column: 59
                    }
                }],
                line: 13
            },
            '1': {
                loc: {
                    start: {
                        line: 21,
                        column: 27
                    },
                    end: {
                        line: 21,
                        column: 59
                    }
                },
                type: 'cond-expr',
                locations: [{
                    start: {
                        line: 21,
                        column: 37
                    },
                    end: {
                        line: 21,
                        column: 52
                    }
                }, {
                    start: {
                        line: 21,
                        column: 55
                    },
                    end: {
                        line: 21,
                        column: 59
                    }
                }],
                line: 21
            }
        },
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0
        },
        b: {
            '0': [0, 0],
            '1': [0, 0]
        },
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_1glj2h5u51.s[0]++;
(function () {
    'use strict';

    cov_1glj2h5u51.f[0]++;
    cov_1glj2h5u51.s[1]++;
    angular.module('app').factory('ReportsTable', RestmodFactory);

    /* @ngInject */
    function RestmodFactory(restmod) {
        cov_1glj2h5u51.f[1]++;
        cov_1glj2h5u51.s[2]++;

        return restmod.model('/reports').mix('MixinContainable', {
            start: {
                decode: function decode(value) {
                    cov_1glj2h5u51.f[2]++;
                    cov_1glj2h5u51.s[3]++;

                    return value ? (cov_1glj2h5u51.b[0][0]++, new Date(value)) : (cov_1glj2h5u51.b[0][1]++, null);
                },
                encode: function encode(value) {
                    cov_1glj2h5u51.f[3]++;
                    cov_1glj2h5u51.s[4]++;

                    return moment(value).format('YYYY-MM-DD');
                }
            },
            end: {
                decode: function decode(value) {
                    cov_1glj2h5u51.f[4]++;
                    cov_1glj2h5u51.s[5]++;

                    return value ? (cov_1glj2h5u51.b[1][0]++, new Date(value)) : (cov_1glj2h5u51.b[1][1]++, null);
                },
                encode: function encode(value) {
                    cov_1glj2h5u51.f[5]++;
                    cov_1glj2h5u51.s[6]++;

                    return moment(value).format('YYYY-MM-DD');
                }
            }
        });
    }
})();